
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"stroke",attrs:{"d":"M10 5V2H14V5M10 5H6C5.44772 5 5 5.44772 5 6V11.3333M10 5H14M5 11.3333L3.08785 11.9707C3.03828 11.9872 3.00979 12.0391 3.02246 12.0898L4.5 18C6 18 8 15.5 8 15.5C8 15.5 10 18 12 18C14 18 16 15.5 16 15.5C16 15.5 18 18 19.5 18L20.9775 12.0898C20.9902 12.0391 20.9617 11.9872 20.9121 11.9707L19 11.3333M5 11.3333L11.9684 9.01054C11.9889 9.0037 12.0111 9.0037 12.0316 9.01054L19 11.3333M2 22H5C6.5 22 8 21 8 21C8 21 10 22 12 22C14 22 16 21 16 21C16 21 17.5 22 19 22H22M14 5H18C18.5523 5 19 5.44772 19 6V11.3333","stroke":"#30373D","stroke-width":"2"}})])
          )
        }
      }
    